import posthog from 'posthog-js'
import { env } from '@/config/env'
import { resolveAnalyticsEnvironment } from './environment'

const MISSING_KEY_WARNING =
  'VITE_POSTHOG_KEY variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_KEY is configured'

let initialized = false

export function isPostHogEnabled(): boolean {
  return initialized
}

/** Initialize PostHog when a project key is present; otherwise warn and no-op (BFP-492). */
export function initPostHog(): boolean {
  const key = env.VITE_POSTHOG_KEY
  if (!key) {
    console.warn(MISSING_KEY_WARNING)
    return false
  }

  posthog.init(key, {
    api_host: env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
  })

  posthog.register({ environment: resolveAnalyticsEnvironment() })
  initialized = true
  return true
}

/** Safe capture — no-op when SDK is not initialized. */
export function captureAnalyticsEvent(
  event: string,
  properties?: Record<string, string | number | boolean | null>
): void {
  if (!initialized) return
  posthog.capture(event, properties)
}

/** Identify SP user after session load — internal user id only (rule 56). */
export function identifySpUser(spUserId: string): void {
  if (!initialized || !spUserId) return
  posthog.identify(spUserId)
}
